export const isEmptyObject = (object: Record<string, unknown>): boolean => {
  return Object.values(object).length === 0
}
